/* eslint-disable no-restricted-imports */
import QrElement from '~/client/shared/QrElement';
import AddressInputs from './AddressInputs';
import CopyButtons from './CopyButtons';
import useQuickDeposit from './useQuickDeposit';
import Loader from '@/external/components/Loader';

type Props = {
  loading: boolean;
  walletInfo: { address: string; destinationTag: string };
  currency: CashierCurrency;
};

const QuickDeposit: FC<Props> = ({ walletInfo, currency, loading }) => {
  const { handleCopy } = useQuickDeposit();

  if (loading) {
    <div className="grid place-items-center gap-4">
      <Loader />
    </div>;
  }

  return (
    <div
      className="grid place-items-center gap-4 [&_div]:grid"
      data-testid="quick-deposit-popup"
    >
      <QrElement value={walletInfo?.address} size={156} />
      <AddressInputs
        walletAddress={walletInfo?.address}
        destinationTag={walletInfo?.destinationTag}
        currency={currency}
        handleCopy={handleCopy}
      />
      <CopyButtons
        walletAddress={walletInfo?.address}
        destinationTag={walletInfo?.destinationTag}
        currency={currency}
        handleCopy={handleCopy}
      />
    </div>
  );
};

export default QuickDeposit;
